import React from "react";
import styled from "styled-components";

const SectionTitleStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-bottom: 20px;

  h2:nth-child(1) {
    color: transparent;
    -webkit-text-stroke: 1px var(--water-color);
  }
  h2:nth-child(2) {
    color: var(--water-color);
    animation: animateWater 4s ease-in-out infinite;
  }
  @keyframes animateWater {
    0%,
    100% {
      clip-path: polygon(
        0% 45%,
        15% 44%,
        32% 50%,
        54% 60%,
        70% 61%,
        84% 59%,
        100% 52%,
        100% 100%,
        0% 100%
      );
    }
    50% {
      clip-path: polygon(
        0% 60%,
        16% 65%,
        34% 66%,
        51% 62%,
        67% 50%,
        84% 45%,
        100% 46%,
        100% 100%,
        0% 100%
      );
    }
  }
`;

const TitleContainer = styled.h2`
  position: absolute;
  margin-bottom: 40px;
  font-size: 60px;
`;

function SectionTitle({ text }) {
  return (
    <SectionTitleStyled>
      <TitleContainer>{text}</TitleContainer>
      <TitleContainer>{text}</TitleContainer>
    </SectionTitleStyled>
  );
}

export default SectionTitle;
